"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.for-each.js");
var _cookie = require("@/utils/cookie");
var _ga = require("@/utils/ga");
var _log = require("@/utils/log");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  props: {
    coin: {
      type: Object,
      default: () => {
        return {
          id: '',
          user: '',
          nextRedeem: '',
          transaction: []
        };
      }
    }
  },
  data() {
    return {
      list: this.coin.transaction,
      listLoading: false,
      totalCoin: 0
    };
  },
  created() {
    // console.log('transaction', this.list)
    this.getTotal();
  },
  methods: {
    getTotal() {
      this.coin.transaction.forEach(tx => {
        // console.log('coin', tx.amount)
        this.totalCoin += tx.amount;
      });
    }
  }
};